module.exports = __webpack_public_path__ + "static/img/616.c4196da.png";